import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_PRODUCTS_STATIC_DATA } from 'mocks/queries';
import useIsRefreshCache from 'hooks/useIsRefreshCache';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useUserLocation from 'global-state/userLocation/useUserLocation';

const useStaticProductsData = ({ productIds }, { skip = false } = {}) => {
  const isRefreshCache = useIsRefreshCache();
  const userLocation = useUserLocation();
  const zipCode = userLocation?.zip ?? '';

  const { data, loading } = useSuspenseQuery(GET_PRODUCTS_STATIC_DATA, {
    fetchPolicy: 'cache-and-network',
    variables: {
      productIds,
      refreshCache: isRefreshCache,
      limit: 12,
      zipCode,
      showSearchProductsOnly: true,
      ...getVisitorLocationQueryVariables(userLocation?.stateShortName),
    },
    skip,
  });

  return {
    products: data?.getProductsStaticData?.products || [],
    upholsteryOptions: data?.getProductsStaticData?.upholsteryOptions || [],
    loading,
  };
};

export default useStaticProductsData;
